import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft, Calendar } from "lucide-react";
import { api } from "../lib/api";

export default function NoticiaDetalhe() {
  const { slug } = useParams();
  const [news, setNews] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    api
      .get(`/news/${slug}`)
      .then((r) => setNews(r.data))
      .catch(() => setErr("Notícia não encontrada."));
  }, [slug]);

  if (err) {
    return (
      <div data-testid="page-noticia-404" className="pt-32 max-w-3xl mx-auto px-6 text-center min-h-[60vh]">
        <h1 className="font-serif-display text-4xl mb-6">{err}</h1>
        <Link to="/noticias" className="text-[#003F88] underline">Voltar para notícias</Link>
      </div>
    );
  }

  if (!news) return <div className="pt-40 text-center text-neutral-500">Carregando…</div>;

  const date = new Date(news.created_at).toLocaleDateString("pt-BR", {
    day: "2-digit", month: "long", year: "numeric",
  });

  return (
    <article data-testid="page-noticia-detail" className="pt-24 md:pt-32 bg-white">
      <div className="max-w-3xl mx-auto px-6 md:px-10 pb-20">
        <Link
          to="/noticias"
          data-testid="back-news"
          className="inline-flex items-center gap-2 text-xs uppercase tracking-widest text-[#003F88]"
        >
          <ArrowLeft size={14} /> Todas as notícias
        </Link>
        <div className="mt-8 flex items-center gap-4 text-[11px] uppercase tracking-widest text-neutral-500">
          <span className="text-[#003F88] font-semibold">{news.category}</span>
          <span className="inline-flex items-center gap-1.5"><Calendar size={12} /> {date}</span>
        </div>
        <h1 className="font-serif-display text-4xl md:text-6xl leading-[0.98] tracking-tight mt-4 text-neutral-900">
          {news.title}
        </h1>
        <p className="mt-6 text-lg md:text-xl text-neutral-600 font-light leading-relaxed">
          {news.excerpt}
        </p>
        {news.cover_image && (
          <img
            src={news.cover_image}
            alt={news.title}
            className="editorial-img w-full h-[280px] md:h-[460px] object-cover my-12"
          />
        )}
        <div className="prose font-body text-lg leading-relaxed text-neutral-800 whitespace-pre-line">
          {news.content}
        </div>
      </div>
    </article>
  );
}
